module.exports = __webpack_public_path__ + "static/media/mira_mvp_thumb.eace3020.png";